import {
  appendNodeIntoTargetNode, isThreeEndConstructor,
  pourDataIntoController
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import {
  firstLetterUpperCase,
  getNodeById
} from '@/components/common/controlBar/controlBarDialog/metaComponent/worker.js'


export function createCssVarityName(customKey, deviceMode) {
  return `--${customKey}_${firstLetterUpperCase(deviceMode)}GlobalPopagation`
}

function createCssVarityValue(value, isOppsite = false){
  if(!isOppsite){
    if(value === 'px'){
      return `1${value}`
    }else{
      return value
    }
  }else{
    if(value === '1px'){
      return value.replace('1', '')
    }else{
      return value
    }
  }

}

export function transformToCssVarity(data = null) {
  if (!data) return ''
  var res = '\n'
  var { design, hover } = data
  for (var customKey in design) {
    res += `${createCssVarityName(customKey, 'diannao')}: ${createCssVarityValue(design[customKey]['diannao'])}; \n`
    res += `${createCssVarityName(customKey, 'pingban')}: ${createCssVarityValue(design[customKey]['pingban'])}; \n`
    res += `${createCssVarityName(customKey, 'shouji')}: ${createCssVarityValue(design[customKey]['shouji'])}; \n`
  }

  for (var customKey in hover) {
    res += `${createCssVarityName(customKey, 'diannao')}: ${createCssVarityValue(hover[customKey]['diannao'])}; \n`
    res += `${createCssVarityName(customKey, 'pingban')}: ${createCssVarityValue(hover[customKey]['pingban'])}; \n`
    res += `${createCssVarityName(customKey, 'shouji')}: ${createCssVarityValue(hover[customKey]['shouji'])}; \n`
  }

  return res
}

export async function getGlobalPopagation() {

  var node = {
    name: '分页',
    componentName: 'popagation',
    flag: 'globalPopagation',
    _type: 'popagation_style1',
    actions: ['design', 'hover'],
    data: {
      ...mm.store.state.authInfo.ksh_global_theme_color.popagation
    }
  }


  return new Promise((resolve) => {
    var globalPopagation = getNodeByFlag(mm.store.state.hasList[1], 'globalPopagation')
    if (!globalPopagation) {

      appendNodeIntoTargetNode(
        node,
        mm.store.state.hasList[1]
      )

      setTimeout(() => {
        globalPopagation = getNodeByFlag(mm.store.state.hasList[1], 'globalPopagation')
        resolve(globalPopagation)
      }, 500)
    } else {
      resolve(globalPopagation)
    }
  })
}

export function showGlobalPopagationDialog() {
  return new Promise((resolve) => {
    getGlobalPopagation().then((globalPopagation) => {
      mm.store.commit('SHOW_SINGLE_DIALOG', globalPopagation)
      setTimeout(() => {
        document.querySelector('.icon-sheji').click()

        var dialog = document.querySelector('.whl-theme-dialog').closest('.el-modal-dialog') || document.querySelector('.whl-theme-dialog').closest('.el-overlay')
        var zIndex = dialog.style.zIndex
        document.querySelector('.controlBar').style.zIndex = Number(zIndex) + 1
        resolve(globalPopagation)
      }, 500)
    })
  })
}

export function getPropertyValueInRootStyle(propertyName) {
  var rootStyle = getComputedStyle(document.querySelector(':root'))
  return rootStyle.getPropertyValue(propertyName)
}

//appendNodeIntoTargetNode(node, recieveNode)
export function switchGlobalAndSelfPopagation(node, dataKey, type) {
  for (var customKey in node.data[dataKey]) {
    if(isThreeEndConstructor(node.data[dataKey][customKey])){
      for (var deviceMode in node.data[dataKey][customKey]) {

        node.data[dataKey][customKey][deviceMode] = (() => {
          if (type === 'global') {
            return `var(${createCssVarityName(customKey, deviceMode)})`
          } else {
            return createCssVarityValue(
              getPropertyValueInRootStyle(createCssVarityName(customKey, deviceMode)),
              true
            )
          }
        })()
      }
    }



  }
  pourDataIntoController(getNodeById(node.id).controllerModule, node.data)
}

export function pickGradientKeys(){
  var res = {}
  if(typeof getComputedStyle === 'function'){
    var rootStyle = getComputedStyle(document.querySelector(':root'))
    for(var index in rootStyle){
      var key = rootStyle[index]
      var value = rootStyle.getPropertyValue(key)
      if(value.indexOf('-gradient') >= 0){
        res[key] = value
      }
    }
  }

  return res
}


export function isAllUseGlobalByDataKey(node, dataKey){
  var res = true
  for(var customKey in node.data[dataKey]){
    for (var deviceMode in node.data[dataKey][customKey]) {
      if(
        !(
          node.data[dataKey][customKey][deviceMode] &&
          node.data[dataKey][customKey][deviceMode].indexOf &&
          node.data[dataKey][customKey][deviceMode].indexOf('var(--') >= 0
        )
      ){
        res = false
      }
    }
  }
  return res

}


export function getDefaultGlobalPopagationValues(){
  return {
    "design": {
      "popagationtext_color": {
        "diannao": "rgb(51, 51, 51)",
        "pingban": "rgb(51, 51, 51)",
        "shouji": "rgb(51, 51, 51)"
      },
      "popagationtext_fontFamily": {
        "diannao": "var(--globalFont)",
        "pingban": "var(--globalFont)",
        "shouji": "var(--globalFont)"
      },
      "popagationtext_fontSize": {
        "diannao": 16,
        "pingban": 16,
        "shouji": 12
      },
      "popagationtext_fontSizeUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "popagationtext_backgroundColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "popagationtext_backgroundImage": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "popagationtext_borderRadiusLeftTop": {
        "diannao": 6,
        "pingban": 6,
        "shouji": 6
      },
      "popagationtext_borderRadiusLeftTopUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "popagationtext_borderRadiusRightTop": {
        "diannao": 6,
        "pingban": 6,
        "shouji": 6
      },
      "popagationtext_borderRadiusRightTopUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "popagationtext_borderRadiusLeftBottom": {
        "diannao": 6,
        "pingban": 6,
        "shouji": 6
      },
      "popagationtext_borderRadiusLeftBottomUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "popagationtext_borderRadiusRightBottom": {
        "diannao": 6,
        "pingban": 6,
        "shouji": 6
      },
      "popagationtext_borderRadiusRightBottomUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "commonItem_paddingTop": {
        "diannao": 12,
        "pingban": 8,
        "shouji": 6
      },
      "commonItem_paddingRight": {
        "diannao": 12,
        "pingban": 8,
        "shouji": 6
      },
      "commonItem_paddingBottom": {
        "diannao": 12,
        "pingban": 8,
        "shouji": 6
      },
      "commonItem_paddingLeft": {
        "diannao": 12,
        "pingban": 8,
        "shouji": 6
      },
      "commonItem_paddingUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "self_marginLeft": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "self_marginRight": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "self_marginTop": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "self_marginBottom": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "self_marginUnit": {
        "diannao": "px",
        "pingban": "px",
        "shouji": "px"
      },
      "popagationnarrowtext_color": {
        "diannao": "rgb(51, 51, 51)",
        "pingban": "rgb(51, 51, 51)",
        "shouji": "rgb(51, 51, 51)"
      },
      "popagationnarrowtext_backgroundColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "popagationnarrowtext_backgroundImage": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "popBorder_borderTopColor": {
        "diannao": "rgb(136, 136, 136)",
        "pingban": "rgb(136, 136, 136)",
        "shouji": "rgb(136, 136, 136)"
      },
      "popBorder_borderRightColor": {
        "diannao": "rgb(136, 136, 136)",
        "pingban": "rgb(136, 136, 136)",
        "shouji": "rgb(136, 136, 136)"
      },
      "popBorder_borderBottomColor": {
        "diannao": "rgb(136, 136, 136)",
        "pingban": "rgb(136, 136, 136)",
        "shouji": "rgb(136, 136, 136)"
      },
      "popBorder_borderLeftColor": {
        "diannao": "rgb(136, 136, 136)",
        "pingban": "rgb(136, 136, 136)",
        "shouji": "rgb(136, 136, 136)"
      },
      "popBorder_borderTopWidth": {
        "diannao": 1,
        "pingban": 1,
        "shouji": 1
      },
      "popBorder_borderRightWidth": {
        "diannao": 1,
        "pingban": 1,
        "shouji": 1
      },
      "popBorder_borderBottomWidth": {
        "diannao": 1,
        "pingban": 1,
        "shouji": 1
      },
      "popBorder_borderLeftWidth": {
        "diannao": 1,
        "pingban": 1,
        "shouji": 1
      },
      "popBorder_borderTopStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "popBorder_borderRightStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "popBorder_borderBottomStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "popBorder_borderLeftStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "narrowBorder_borderTopColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "narrowBorder_borderRightColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "narrowBorder_borderBottomColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "narrowBorder_borderLeftColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "narrowBorder_borderTopWidth": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "narrowBorder_borderRightWidth": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "narrowBorder_borderBottomWidth": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "narrowBorder_borderLeftWidth": {
        "diannao": 0,
        "pingban": 0,
        "shouji": 0
      },
      "narrowBorder_borderTopStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "narrowBorder_borderRightStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "narrowBorder_borderBottomStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      },
      "narrowBorder_borderLeftStyle": {
        "diannao": "solid",
        "pingban": "solid",
        "shouji": "solid"
      }
    },
    "hover": {
      "popagationtext_hoverColor": {
        "diannao": "#fff",
        "pingban": "#fff",
        "shouji": "#fff"
      },
      "popagationtext_hoverBackgroundColor": {
        "diannao": "rgb(136, 136, 136)",
        "pingban": "rgb(136, 136, 136)",
        "shouji": "rgb(136, 136, 136)"
      },
      "popagationtext_hoverBackgroundImage": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "popagationnarrowtext_hoverColor": {
        "diannao": "rgb(136, 136, 136)",
        "pingban": "rgb(136, 136, 136)",
        "shouji": "rgb(136, 136, 136)"
      },
      "popagationnarrowtext_hoverBackgroundColor": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      },
      "popagationnarrowtext_hoverBackgroundImage": {
        "diannao": "",
        "pingban": "",
        "shouji": ""
      }
    }
  }
}
